import ClusterClass, * as ClusterModule from './../../node_modules/ol/source/Cluster.js';

class Cluster extends ClusterClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ClusterModule) {
    if (key !== "default") {
        Cluster[key] = ClusterModule[key];
    }
}

export default Cluster;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/Cluster.js';